/** 8-color OKLCH project palette (L 0.53, C 0.13, equal hue steps). */
export const PROJECT_COLOR_HEXES = [
  '#aa4844',
  '#9a5b00',
  '#6a7300',
  '#008251',
  '#007f8f',
  '#226fb3',
  '#725aae',
  '#9b4a83',
];

export const PROJECT_COLOR_COUNT = PROJECT_COLOR_HEXES.length;

/** Tie-break order when picking the least-used palette index. */
export const PROJECT_COLOR_ASSIGN_ORDER = [
  0,
  4,
  2,
  PROJECT_COLOR_COUNT - 2,
  1,
  5,
  3,
  7,
];

/**
 * @param {number[]} colorIndices — existing project color fields (0–7)
 * @returns {number}
 */
export const pickLeastUsedColorIndex = (colorIndices = []) => {
  const counts = Array(PROJECT_COLOR_COUNT).fill(0);
  for (const raw of colorIndices) {
    const i = Number(raw);
    if (Number.isInteger(i) && i >= 0 && i < PROJECT_COLOR_COUNT) {
      counts[i] += 1;
    }
  }
  const minCount = Math.min(...counts);
  for (const idx of PROJECT_COLOR_ASSIGN_ORDER) {
    if (counts[idx] === minCount) return idx;
  }
  return PROJECT_COLOR_ASSIGN_ORDER[0];
};

/**
 * @param {Map<string, number> | Record<string, number>} colorMap
 * @returns {number[]}
 */
export const colorIndicesFromMap = (colorMap) => {
  if (!colorMap) return [];
  const values =
    colorMap instanceof Map ? [...colorMap.values()] : Object.values(colorMap);
  return values.filter(
    (v) => Number.isInteger(v) && v >= 0 && v < PROJECT_COLOR_COUNT,
  );
};

const stringToPaletteIndex = (str) => {
  if (typeof str !== 'string' || !str) return 0;
  const charCodeSum = str
    .split('')
    .reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return charCodeSum % PROJECT_COLOR_COUNT;
};

/**
 * @param {string} projectTagId — lowercase tag id
 * @param {number | null | undefined} [storedIndex]
 */
export const resolveProjectColorIndex = (projectTagId, storedIndex) => {
  if (
    Number.isInteger(storedIndex) &&
    storedIndex >= 0 &&
    storedIndex < PROJECT_COLOR_COUNT
  ) {
    return storedIndex;
  }
  return stringToPaletteIndex(
    typeof projectTagId === 'string' ? projectTagId.toLowerCase() : '',
  );
};

/**
 * @param {string} projectTagId
 * @param {number | null | undefined} [storedIndex]
 */
export const resolveProjectColorHex = (projectTagId, storedIndex) => {
  if (typeof projectTagId !== 'string' || !projectTagId) return 'transparent';
  const index = resolveProjectColorIndex(projectTagId, storedIndex);
  return PROJECT_COLOR_HEXES[index];
};
